import { TreeDataNode } from "antd";

export const dataTypeTreeDataForCash: TreeDataNode[] = [
  {
    title: "Cash on Balance Sheet",
    key: "Cash on Balance Sheet",
    isLeaf: true,
  },
  {
    title: "Marketable Securities",
    key: "Marketable Securities",
      isLeaf: true,
  },
  {
    title: "Non-Marketable Securities",
    key: "Non-Marketable Securities",
    isLeaf: true,
  },
  {
    title: "Restricted Cash",
    key: "Restricted Cash", 
      isLeaf: true,
  },
  {
    title: "Derivative Instruments ",
    key: "Derivative Instruments ",
    children: [
      { 
        title: "Assets", 
        key: "Cash Instruments_Derivative Instruments_Assets", 
        isLeaf: true,
      },
      {
        title: "Liabilities",
        key: "Cash Instruments_Derivative Instruments_Liabilities",
        isLeaf: true,
      },
      {
        title: "Net",
        key: "Cash Instruments_Derivative Instruments_Net",
        isLeaf: true,
      }
    ],
  },

  {
    title: "Divestitures",
    key: "Cash Instruments_Divestitures",
    children: [
      { title: "Assets Held for Sale", key: "Cash Instruments_Divestitures_Assets Held for Sale", 
        isLeaf: true,
      },
      { title: "Other Divested Assest", key: "Cash Instruments_Divestitures_Other Divested Assest", 
        isLeaf: true,
      },
      { title: "Total", key: "Cash Instruments_Divestitures_Total", 
        isLeaf: true,
      },
    ],
  },
  {
    title: "Other Cash Like Items",
    key: "Cash Instruments_Other Cash Like Items",
    children: [
      { title: "Digital Assets", key: "Cash Instruments_Other Cash Like Items_Digital Assets", 
        isLeaf: true,
      },
      { title: "Other Cash-Like Assets", key: "Cash Instruments_Divestitures_Other Cash-Like Assets", 
        isLeaf: true,
      },
      { title: "Total", key: "Cash Instruments_Other Cash Like Items_Total", 
        isLeaf: true,
      },
    ],
  }
  

];
